import { Check, Palette } from "lucide-react";
import * as React from "react";
import { cn } from "../../lib/utils";
import { ColorTheme } from "../../types";
import { useTheme } from "../theme-provider";
import { Button } from "./button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./dropdown-menu";

export const COLOR_THEMES: {
  value: ColorTheme;
  label: string;
  swatch: string;
}[] = [
  { value: "flame", label: "Flame (default)", swatch: "bg-flame" },
  { value: "sky", label: "Sky", swatch: "bg-avahana-500" },
  { value: "violet", label: "Violet", swatch: "bg-violet-500" },
  { value: "emerald", label: "Emerald", swatch: "bg-emerald-500" },
  { value: "rose", label: "Rose", swatch: "bg-rose-500" },
  { value: "amber", label: "Amber", swatch: "bg-amber-500" },
  { value: "slate", label: "Slate", swatch: "bg-slate-600" },
];

export function ThemeSelector() {
  const { colorTheme, setColorTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" aria-label="Select theme">
          <Palette className="h-[1.2rem] w-[1.2rem]" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>Accent theme</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {COLOR_THEMES.map((t) => (
          <DropdownMenuItem
            key={t.value}
            onClick={() => setColorTheme(t.value)}
            className="gap-2"
          >
            <span
              className={cn("h-4 w-4 shrink-0 rounded-full", t.swatch)}
              aria-hidden="true"
            />
            <span className="flex-1">{t.label}</span>
            {colorTheme === t.value ? <Check className="h-4 w-4" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
